import axios from "axios";
import { useState } from "react";

const useSendPushNotification = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const sendPushNotification = async (
    registration_id = null,
    list_registration_id = [],
    title,
    body,
    action,
    notificationType
  ) => {
    const formData = new FormData();

    formData.append("title", title);
    formData.append("body", body);
    formData.append("action", action);
    formData.append("notification_type", notificationType);

    if (notificationType === "notification_all") {
      // No additional data needed
    } else if (notificationType === "notification_many") {
      formData.append(
        "list_registration_id",
        JSON.stringify(list_registration_id)
      );
    } else if (notificationType === "notification_user") {
      formData.append("registration_id", registration_id);
    }

    const isDev = process.env.NODE_ENV === "development";
    const pushNotifUrl = isDev
      ? "/dev/push_notification"
      : `${process.env.REACT_APP_PUSH_NOTIF_URL}/dev/push_notification`;

    try {
      const result = await axios.post(pushNotifUrl, formData, {
        headers: {
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "Content-Type": "multipart/form-data",
          "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        },
      });

      setResponse(result.data);
      setError(null);
    } catch (err) {
      setError(err.response ? err.response.data : err.message);
      setResponse(null);
    }
  };

  return { sendPushNotification, response, error };
};

export default useSendPushNotification;
